import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  LinearProgress,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { confirmMaterialsDialog, setConfirmMaterials, setSnackbar } from '../redux';
import { asyncFetch } from '../../helperFunctions';

export default () => {
  const dispatch = useDispatch();
  const dialog = useSelector(state => state.tasks.confirmMaterialsDialog);
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (dialog) {
        setLoading(true);
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/get-materials`,
          {},
          {},
          undefined,
          dispatch
        );
        setLoading(false);
        if (response) {
          setMaterials(response.confirmMaterials);
        }
      }
    })();
  }, [dialog, dispatch]);

  return dialog ? (
    <Dialog open={dialog} fullScreen>
      <ButtonGroup style={{ position: 'sticky', width: '100%', top: '0', zIndex: '100' }}>
        <Button
          onClick={async () => {
            dispatch(confirmMaterialsDialog(false));
            if (materials.length === 0) {
              return;
            }
            setLoading(true);
            const response = await asyncFetch(
              `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/confirm-notification-data`,
              {},
              {},
              undefined,
              dispatch
            );
            setLoading(true);

            if (response && response.isSuccess) {
              dispatch(setConfirmMaterials([]));
              setMaterials([]);
            } else {
              dispatch(setSnackbar({ open: true, message: response.errorMessage }));
            }
          }}
          variant="contained"
          style={{ width: '100%' }}
        >
          <Typography>Затвори</Typography>
        </Button>
      </ButtonGroup>
      {loading && <LinearProgress />}
      {materials.length > 0 ? (
        <TableContainer
          style={{
            display: 'fixed',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '20px',
          }}
        >
          <Table className="RedResults" aria-label="simple table">
            <TableHead style={{ backgroundColor: '#c2c0ba' }}>
              <TableRow>
                <TableCell align="center">Ид на материал</TableCell>
                <TableCell align="center">Сериен номер</TableCell>
                <TableCell align="center">Име на материал</TableCell>
                <TableCell align="center">Количество</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {materials.map(row => (
                <TableRow key={row.materialId + row.materialName}>
                  <TableCell align="center" component="th" scope="row">
                    {row.materialId}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {row.serialNumber ? row.serialNumber : ''}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {row.materialName}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {row.quantity}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <></>
      )}

      {materials.length === 0 && loading === false ? (
        <Typography style={{ padding: '20px' }}>Няма известия за материали</Typography>
      ) : (
        <></>
      )}
    </Dialog>
  ) : (
    <></>
  );
};
